import {BaseService} from '../base.service';
import {environment} from '../../../../environments/environment';
import {Injectable} from '@angular/core';



@Injectable()

export class CoursesService extends BaseService {

  public getAllCourses(moduleId: number){
    return this.getBaseInfo(`${environment.baseUrl}/service/webapi/v1/courses/${moduleId}`);
  }

  public sertificate(courseId:number){
    return this.downloadRequest(`${environment.baseUrl}/service/webapi/v1/certificates/courses/${courseId}/download`)
  }
  public getInfoGlobalTest(courseId:number){
    return this.getBaseInfo(`${environment.baseUrl}/service/webapi/v1/tests/submitted?courseId=${courseId}`);
  }

}
